import { createRoutine, bindRoutineToReduxForm } from "redux-saga-routines";

export const initWalletRoutine = createRoutine("wallet/INIT");

export const getProvidersRoutine = createRoutine("wallet/GET_PROVIDERS");
export const selectProviderRoutine = createRoutine("wallet/SELECT_PROVIDER");
export const triggerTxRoutine = createRoutine("wallet/TRIGGER_TX");
export const logoutRoutine = createRoutine("wallet/LOGOUT");
